import Vue from 'vue'
import { Drag, Drop } from 'vue-drag-drop'
import vuetify from '@/plugins/vuetify' // path to vuetify expor

import App from './App.vue'
import router from './routes'
import store from './store'
import ClickOutside from './directives/click-outside'

import {
  Input,
  Toast,
  Checkbox,
  Button,
  Tab,
  Card,
  SearchBar,
  Datatable,
  Chart,
  Icon,
  Select,
  MultiSelect,
  ModalOverlay,
  ConfirmationModal,
  RadioButton,
  Textarea,
  Toggle,
  ProgressBar,
  HorizontalTimebar,
  Loader,
  BottomSheet,
  Menu,
  Tooltip,
  Daterange,
  DateTimePicker
} from './components/common'

Vue.config.productionTip = false

Vue.component('bh-input', Input)
Vue.component('bh-toast', Toast)
Vue.component('bh-checkbox', Checkbox)
Vue.component('bh-button', Button)
Vue.component('bh-loader', Loader)
Vue.component('bh-textarea', Textarea)
Vue.component('bh-radio-button', RadioButton)
Vue.component('bh-card', Card)
Vue.component('bh-search-bar', SearchBar)
Vue.component('bh-table', Datatable)
Vue.component('bh-chart', Chart)
Vue.component('bh-icon', Icon)
Vue.component('bh-select', Select)
Vue.component('bh-multi-select', MultiSelect)
Vue.component('bh-confirmation-modal', ConfirmationModal)
Vue.component('bh-modal-overlay', ModalOverlay)
Vue.component('drag', Drag)
Vue.component('drop', Drop)
Vue.component('bh-horizontal-timebar', HorizontalTimebar)
Vue.component('bh-toggle', Toggle)
Vue.component('bh-progress-bar', ProgressBar)
Vue.component('bh-bottom-sheet', BottomSheet)
Vue.component('bh-tab', Tab)
Vue.component('bh-menu', Menu)
Vue.component('bh-tooltip', Tooltip)
Vue.component('bh-daterange', Daterange)
Vue.component('bh-date-time-picker', DateTimePicker)

// Directives
Vue.directive('click-outside', ClickOutside)

new Vue({
  router,
  store,
  render: h => h(App),
  vuetify
}).$mount('#app')
